<template>
  <section :style="styles">
    <div :style="icon.styles">
      <feather :type="icon.type" :size="icon.size" />
    </div>
    <div :style="data.styles">
      <span>
        {{ data.title }}
      </span>
      <span>
        {{ data.data }}
      </span>
    </div>
  </section>
</template>

<script>
export default {
	props: {
		icon: {
			type: Object,
			default: () => ({ type: 'archive', size: '12px', styles: { backgroundColor: '#FFF' } }),
		},
		data: {
			type: Object,
			default: () => (
				{
					title: 'RGIE',
					data: 'fdsdfksf',
					styles: {
						display: 'flex',
						flexDirection: 'column'
					}
				}),
		},
		width: {
			type: String,
			default: 'unset',
		},
		height: {
			type: String,
			default: 'unset',
		},
		fontSize: {
			type: String,
			default: '12px',
		},
		padding: {
			type: String,
			default: '5px',
		},
		whiteSpace: {
			type: String,
			default: 'nowrap',
		},
		borderRadius: {
			type: String,
			default: '5px',
		},
		color: {
			type: String,
			default: '#4caf50',
		},
		fontWeight: {
			type: String,
			default: 'bold',
		},
		marginTop: {
			type: String,
			default: '0',
		},
		marginRight: {
			type: String,
			default: '0',
		},
		alignItems: {
			type: String,
			default: 'center',
		},
		display: {
			type: String,
			default: 'flex',
		}
	},
	computed: {
		styles() {
			return {
				width: this.width,
				height: this.height,
				fontSize: this.fontSize,
				backgroundColor: `${this.color}31`,
				whiteSpace: this.whiteSpace,
				padding: this.padding,
				borderRadius: this.borderRadius,
				color: this.color,
				fontWeight: this.fontWeight,
				marginTop: this.marginTop,
				marginRight: this.marginRight,
				display: this.display,
				alignItems: this.alignItems,
				cursor: 'pointer',
			};
		}
	}
};
</script>

<style>

</style>
